(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-counters"] && !Shopify.designMode) return;
  try {
    
let cs = document.querySelectorAll('.wt-counter');
cs.forEach((c) => {
	let cnum = c.getAttribute('data-wt-count');
	let cnumstr = cnum.toString();
	let textnum = cnumstr.split('');
	for(i=0, l = textnum.length; i < l; i++){
		let cdigit = document.createElement('div');
		cdigit.classList.add('counter-digit', 'active');
		let cdclass = 'frame' + textnum[i];
		cdigit.setAttribute('data-wt-digit', textnum[i]);
		cdigit.classList.add(cdclass);
		c.appendChild(cdigit);
	}
  let cdigitL = document.createElement('div');
		cdigitL.classList.add('counter-digit', 'plus');
  cdigitL.textContent = '+';
  c.appendChild(cdigitL);
});

let coptions = {
	threshold: [0]
};

const cobserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		
		if (entry.isIntersecting) {
			entry.target.classList.add('active');
			entry.target.classList.remove('reset');
		} else  {
			entry.target.classList.remove('active');
			entry.target.classList.add('reset');
		}
	});
}, coptions);

if(cs) {
	cs.forEach((c) => {
		cobserver.observe(c);
	});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-promo-items"] && !Shopify.designMode) return;
  try {
    
let wtppsels = document.querySelectorAll('.wt-promo-product-info select');
if(wtppsels) {
    wtppsels.forEach((wtppsel) => {
        wtppsel.addEventListener('change', (event) => {
            let baseid = wtppsel.getAttribute('form');
            let valelid = 'wt-promo-product-id-' + baseid;
            let selectedv = event.target.value;
            let selectedel = wtppsel.querySelector(`option[value="${selectedv}"]`);
            let selectedid = selectedel.getAttribute('data-option-value-id');
            let newvalel = document.querySelector('#' + valelid);
            console.log(selectedv);
            newvalel.setAttribute('value', selectedid);
        });
    });
}
/*let wtpatcs = document.querySelectorAll('.wt-promo-item-atc-btn');
if(wtpatcs) {
    wtpatcs.forEach((wtpatc) => {
        wtpatc.addEventListener('click', () => {
            let tpid = wtpatc.getAttribute('data-wt-promo-product-id');
            let formData = {
                'items': [{
                    'id': tpid,
                    'quantity': 1
                }]
                };

                fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
                })
                .then(response => {
                return response.json();
                })
                .then(data => {
                console.log('Item added to cart:', data);
                })
                .catch((error) => {
                console.error('Error:', error);
                });
        });
    });
}*/


  } catch(e) { console.error(e); }
})();
})();
